App.Routers.PhotoshootConfirmation = Backbone.Router.extend({
  routes: {
    '*hash': 'index',
    '': 'index',
  },

  index: function () {
    if (App.config == null) {
      App.initVenue(null);
    }
  },
});
